import React, { Component } from 'react';
import { SketchPicker } from 'react-color';
import { Button, ButtonToolbar, Modal, Form, FormGroup } from 'react-bootstrap'

export class LineColorShadeForm extends Component {
    render() {
        let { lineColorSelected, shadeSelected, index, title } = this.props;
        let length = lineColorSelected.shades.length;
        let defaultColor =
            shadeSelected !== undefined ?
                shadeSelected.id !== undefined ?
                    shadeSelected.val
                    : length !== 0 ?
                        lineColorSelected.shades[length - 1].val
                        : lineColorSelected.backColor
                : null;

        return (
            typeof lineColorSelected !== 'undefined' && shadeSelected !== undefined
                ?
                <Modal bsSize="small" show={this.props.show}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup controlId="formShade">
                                <SketchPicker className="sketch-picker" color={defaultColor} onChangeComplete={(color) => shadeSelected = color !== undefined ? color : defaultColor} />
                            </FormGroup>
                        </Form>

                        <ButtonToolbar>
                            <Button onClick={() => {
                                if ('Criar' === title) {
                                    if (shadeSelected !== undefined) {
                                        this.props.onChangeValue(shadeSelected, 'shade');
                                    }
                                } else {
                                    this.props.onEditShadeValue(shadeSelected, index);
                                }

                                this.props.onHide();
                            }
                            }>
                                CONCLUÍDO
                            </Button>
                        </ButtonToolbar>

                    </Modal.Body>
                </Modal >
                : null
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lineColors/lineColorShades/LineColorShadeForm.js